import { Settings } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { PageContainer } from 'src/shared/components/PageContainer'
import { useLocalization } from 'src/shared/hooks/useLocalization'

import { OrganizationSettingsTabs } from './OrganizationSettingsTabs'

export const MyAccountPage = () => {
  const { t } = useLocalization()

  return (
    <PageContainer>
      <Column className="gap-4">
        <Row className="items-center gap-2">
          <Settings className="h-5 w-5" />
          <h1 className="text-2xl">{t('Settings', 'Inställningar')}</h1>
        </Row>

        <OrganizationSettingsTabs />

        <div className="h-10" />
      </Column>
    </PageContainer>
  )
}
